module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/step4-pict03-ef3cc41e9df72c02a79f87d2b2a45c1d.jpg";